import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedName from 'I18n/components/FormattedName';
import Small from 'UIComponents/elements/Small';
import UICheckbox from 'UIComponents/input/UICheckbox';
import UITooltip from 'UIComponents/tooltip/UITooltip';
// @ts-expect-error dependency missing types
import UIAvatar from 'ui-addon-avatars/UIAvatar';
import { ApprovalStepStatus } from '../../types';
import ApprovalStepStatusText from '../sidebar/ApprovalStepStatusText';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ApprovalEditPanelTableCheckboxRow = props => {
  const {
    approver,
    changeCheckbox,
    checkboxIsApproved,
    checkboxIsDisabled,
    checkboxIsRequester,
    checkboxIsSelected
  } = props;
  const testId = `approval-checkbox-row-${approver.ownerId}`;
  return /*#__PURE__*/_jsx("tr", {
    "data-test-id": testId,
    children: /*#__PURE__*/_jsx("td", {
      colSpan: 2,
      children: /*#__PURE__*/_jsxs("div", {
        className: "align-center justify-between",
        children: [/*#__PURE__*/_jsx(UITooltip, {
          disabled: !checkboxIsDisabled,
          placement: "left",
          title: checkboxIsRequester ? /*#__PURE__*/_jsx(FormattedMessage, {
            message: "productApprovals.ApprovalEditPanel.tooltipRequesterDisabled"
          }) : /*#__PURE__*/_jsx(FormattedMessage, {
            message: "productApprovals.ApprovalEditPanel.tooltipApproverApproved"
          }),
          children: /*#__PURE__*/_jsx(UICheckbox, {
            alignment: "center",
            checked: checkboxIsSelected,
            "data-test-id": `edit-panel-checkbox-${approver.email}`,
            disabled: checkboxIsDisabled,
            onChange: () => changeCheckbox(approver.ownerId),
            children: /*#__PURE__*/_jsx(_Fragment, {
              children: /*#__PURE__*/_jsxs("span", {
                className: "align-center",
                children: [/*#__PURE__*/_jsx(UIAvatar, {
                  className: "m-right-3 m-left-3",
                  hubSpotUserEmail: approver.email
                }), /*#__PURE__*/_jsxs("span", {
                  className: "flex-column",
                  children: [/*#__PURE__*/_jsx(FormattedName, {
                    givenName: approver.firstName,
                    familyName: approver.lastName
                  }), /*#__PURE__*/_jsx(Small, {
                    use: "help",
                    children: approver.email
                  })]
                })]
              })
            })
          })
        }), checkboxIsApproved && /*#__PURE__*/_jsx(ApprovalStepStatusText, {
          approvalStepStatus: ApprovalStepStatus.APPROVED
        })]
      })
    })
  }, approver.ownerId);
};
export default ApprovalEditPanelTableCheckboxRow;